import { render, staticRenderFns } from "./PayMerchantModal.vue?vue&type=template&id=61472c10&"
import script from "./PayMerchantModal.vue?vue&type=script&lang=js&"
export * from "./PayMerchantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports